import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MailButtonField } from '../../../models/Field';

@Component({
  selector: 'mail-button',
  template: `<div [formGroup]="form" class="form-group">
    <label [attr.for]="fieldKey" style="display: block">{{
      field.label
    }}</label>
    <div style="position: relative;">
      <textarea
        [formControlName]="field.key"
        class="form-control"
        [style.width]="field.size ? field.size + 'em' : ''"
        style="max-width: 100%; min-height:6em; min-width: 12em;"
        rows="5"
        id="{{ field.key }}"
        name="{{ field.key }}"
        placeholder="{{ field.placeholder }}"
        value="{{ field.value }}"
        spellcheck="false"
      ></textarea>
      <a
        class="btn btn-default"
        [class.disabled]="this.control.disabled"
        [id]="field.key + '-mail-btn'"
        style="max-width: 100%; display: inline-block; font-weight: 400; position: absolute; bottom: 1px; left: 1px; z-index: 10; border-left: none; border-bottom: none;"
        type="button"
        (click)="clickHandler()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-envelope"
          viewBox="0 0 16 16"
          style="vertical-align:middle; margin-right:0.5em;"
        >
          <path
            d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383l-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"
          /></svg
        >Send email</a
      >
    </div>
    <error-box [form]="form" [field]="field"></error-box>
  </div>`,
})
export class MailBoxComponent {
  @Input() field: MailButtonField;
  @Input() form: FormGroup;

  get control() {
    return this.form.controls[this.field.key];
  }
  get errorKeys() {
    return Object.keys(this.control.errors);
  }

  clickHandler() {
    const hrefValue = this.hrefValue();
    $(`#${this.field.key}-mail-btn`).attr('href', hrefValue);
  }

  hrefValue() {
    return 'mailto:?body=' + encodeURIComponent($(`#${this.field.key}`).val());
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/mail-box/mail-box.component.ts